import { render } from "./StepOficial.vue?vue&type=template&id=014d5b6e&ts=true"
import script from "./StepOficial.vue?vue&type=script&lang=ts"
export * from "./StepOficial.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\wamp64\\www\\hayllissac\\sistema\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__